import {
  Vuetable, VuetablePagination, VuetablePaginationInfo, VuetableFieldCheckbox,
} from 'vuetable-2';
import axios from 'axios';
import { mapMutations } from 'vuex';
// import rmpInput from '../../js/components/form/input.vue';
import rmpInput from '@rmpenterprise/form-input';
import '@rmpenterprise/form-input/dist/input.esm.css';

export default {
  data() {
    return {
      additionalParams: {
        search: '',
      },
      paginationInfoConfig: {
        css: {
          infoClass: 'view-all',
        },
        infoTemplate: 'Displaying {from} to {to} of {total}',
      },
      paginationConfig: {
        css: {
          wrapperClass: 'vue-table-pagination pagination',
          activeClass: 'active',
          disabledClass: 'disabled',
          pageClass: 'page-item',
          linkClass: 'icon item',
          icons: {
            first: 'Icon Icon-angle-double-left',
            prev: 'Icon Icon-chevron-left',
            next: 'Icon Icon-chevron-right',
            last: 'Icon Icon-angle-double-right',
          },
        },
      },
      tableConfig: {
        css: {
          tableClass: 'Table',
          loadingClass: 'loading',
          ascendingIcon: 'Icon Icon-sort-down',
          descendingIcon: 'Icon Icon-sort-up',
          detailRowClass: 'vuetable-detail-row',
          handleIcon: 'grey sidebar icon',
          sortableIcon: 'Icon Icon-circle',
          ascendingClass: 'is-active',
          descendingClass: 'is-active',
        },
      },
    };
  },
  components: {
    'vue-table': Vuetable,
    VuetablePaginationInfo,
    'vuetable-pagination': VuetablePagination,
    'rmp-input': rmpInput,
    VuetableFieldCheckbox,
  },
  computed: {
    globalLoadingState() {
      return this.$store.state.ui.loading;
    },
    countTableDataContent() {
      // Handle case when there are two data-tables on one page
      // Assumes refs are set as vuetable and vuetableTwo
      return this.$refs.vuetable ? this.$refs.vuetable.countTableData : this.$refs.vuetableTwo.countTableData;
    },
  },
  created() {
    this.$bus.$on('refresh-table', () => {
      this.submitSearch();
    });
  },
  methods: {
    ...mapMutations({
      setLoadingState: 'setLoadingState',
    }),
    getTableData(apiUrl, httpOptions) {
      return axios.get(apiUrl, httpOptions);
    },
    handleDataTableError({ response }) {
      if (response.data.status === 401) {
        window.location.href = '/login';
      }
    },
    onPaginationData(paginationData) {
      if (this.$refs.pagination) {
        this.$refs.pagination.setPaginationData(paginationData);
      }
      if (this.$refs.paginationInfo) {
        this.$refs.paginationInfo.setPaginationData(paginationData);
      }
    },
    setTableStatus() {
      this.loadingState = false;
      const thereIsData = this.countTableDataContent === 0 && this.additionalParams.search.length === 0;
      this.ui.hideFilters = !thereIsData;

      // @Todo Handle multiple data tables. Refs are not reactive to computed propery countTableDataContent will no work
      // Evaluate in this callback instead
      this.ui.showPlaceHolder = this.$refs.vuetable.countTableData === 0;
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },

    submitSearch() {
      this.$refs.vuetable.refresh();
    },
  },
};
